import { useState, useEffect } from 'react'
import _ from 'lodash'
import posIcon from '../assets/map-location.png';

const doSearchThrottle = _.throttle(
  (onSearched, autocomplete, keyword) => {
    console.log('新 key is ------------------> ',keyword)
    autocomplete.search(keyword, function (status, result) {
      console.log(status,result,888);
      
      if (status === 'complete') {
        if (result?.count > 0 && result?.tips) {
          onSearched(result?.tips)
        } else {
          onSearched([])
        }
      }
    })
  },
  300,
  {
    leading: false,
    trailing: true
  }
)

export default (props) => {
  const { __map__, keyword, onSearched, city = '全国' } = props
  const [autocomplete, setAutocomplete] = useState<any>(null)

  useEffect(() => {
    console.log('Auto Complete city >>>>> ', city);
    __map__.plugin(['AMap.Autocomplete', 'AMap.PlaceSearch'], function () {
      setAutocomplete(
        new AMap.Autocomplete({
          city,
        })
      )
    });

    // 创建一个 Icon
    const geolocationIcon = new AMap.Icon({
      // 图标尺寸
      size: new AMap.Size(50, 50),
      // 图标的取图地址
      image: posIcon,
      // 图标所用图片大小
      imageSize: new AMap.Size(50, 50),
      // 图标取图偏移量
      // imageOffset: new AMap.Pixel(-9, -3)
    });

    AMap.plugin('AMap.Geolocation', function() {
      var geolocation = new AMap.Geolocation({
          enableHighAccuracy: true,//是否使用高精度定位，默认:true
          timeout: 10000,          //超过10秒后停止定位，默认：5s
          convert: true,
          panToLocation: true,
          // zoom: 26,
          // position:'RB',    //定位按钮的停靠位置
          // offset: [20, 20], //定位按钮与设置的停靠位置的偏移量，默认：[10, 20]
          buttonPosition: 'RB',    //定位按钮停靠位置，默认：'LB'，左下角
          buttonOffset: new AMap.Pixel(10, 20), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
          showCircle: true,        //定位成功后用圆圈表示定位精度范围，默认：true
          zoomToAccuracy: true,   //定位成功后是否自动调整地图视野到定位点
          markerOptions: {
            animation: 'AMAP_ANIMATION_DROP',
            icon: geolocationIcon
          }

      });
      __map__.addControl(geolocation);
      geolocation.getCurrentPosition(function(status,result){
        console.log('gggggggggggggggggggggggggggggggg result', status, result);
          // if(status=='complete'){
          //     onComplete(result)
          // }else{
          //     onError(result)
          // }
      });
  });
  }, [city])

  useEffect(() => {
    if (autocomplete && keyword) {
      doSearchThrottle(onSearched, autocomplete, keyword)
    }
  }, [keyword, autocomplete])

  return null
}
